<template>
  <PageWrapper
    :isDense="isDense"
    :isLoading="isLoading"
    hasFilters
    @submitFilters="setPageNumberAndSendRequest"
  >
    <template #title>اساتید کلاس گروهی</template>
    <template #titleBtn v-if="selectedGroupClassId">
      <BButton variant="success" @click="renderAddMasterToGroupClassDialog">
        افزودن استاد به کلاس
      </BButton>
    </template>
    <template #filters>
      <SearchInput
        class="filters-width w-24"
        inputId="searchCommand"
        inputLabel="نام استاد"
        inputPlaceholder="علی..."
        v-model.trim="groupClassMasterListFilters.searchCommand"
        @enter="setPageNumberAndSendRequest"
      ></SearchInput>
      <GroupClassStatusPicker
        class="filters-width w-24"
        v-model="groupClassMasterListFilters.groupClassStatus"
      ></GroupClassStatusPicker>
    </template>
    <CustomTable
      v-if="groupClassMastersList"
      :pageNumber="groupClassMasterListFilters.pageNumber"
      :count="groupClassMasterListFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="groupClassMastersList"
      @changePage="changePage"
    >
      <template #masterFullName="data">
        <b-link :to="`/users/${data.item.masterId}`">
          {{ data.item.masterFullName }}
        </b-link>
      </template>

      <template #groupClassStatus="data">
        <BBadge
          class="font-weight-normal"
          :variant="
            groupClassPersianStatuses[data.item.groupClassStatus].variant
          "
        >
          {{ groupClassPersianStatuses[data.item.groupClassStatus].title }}
        </BBadge>
      </template>

      <template #groupClassName="data">
        <b-link :to="`/apps/group-class/${data.item.groupClassId}`">
          {{ data.item.groupClassName }}
        </b-link>
      </template>

      <template #enable="data">
        <BBadge
          class="font-weight-normal"
          :variant="data.item.enable ? 'success' : 'danger'"
        >
          {{ data.item.enable ? "بله" : "خیر" }}
        </BBadge>
      </template>

      <template #actions="data">
        <b-link :to="`/master/group-classes/${data.item.id}`">
          <FeatherIcon icon="ExternalLinkIcon" size="23" class="text-info" />
        </b-link>

        <BButton
          variant="transparent"
          size="sm"
          @click="renderDeleteMasterFromGroupClassConfirmationDialog(data.item)"
        >
          <FeatherIcon icon="Trash2Icon" size="23" class="text-danger" />
        </BButton>
      </template>
    </CustomTable>
    <DeleteMasterFromGroupClassConfirmationDialog
      :defaultSelectedMaster="tempSelectedMaster"
      @refetch="getAllMastersForGroupClass"
    ></DeleteMasterFromGroupClassConfirmationDialog>
    <AddMasterToGroupClassDialog
      :selectedGroupClassId="selectedGroupClassId"
      @refetch="getAllMastersForGroupClass"
    ></AddMasterToGroupClassDialog>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    isDense: {
      type: Boolean,
      default: false,
    },
    selectedGroupClassId: {
      type: [String, Number],
    },
  },
  mounted() {
    this.getAllMastersForGroupClass();
  },
  data() {
    return {
      isLoading: false,
      groupClassMastersList: null,
      totalCount: null,
      tempSelectedMaster: null,
      groupClassMasterListFilters: {
        pageNumber: 1,
        count: 10,
        searchCommand: null,
        groupClassStatus: null,
        groupClassId: null,
      },
      groupClassPersianStatuses: {
        0: {
          title: "جدید",
          variant: "success",
        },
        1: {
          title: "در انتظار تایید",
          variant: "warning ",
        },
        2: {
          title: "در حال ثبت نام",
          variant: "info",
        },
        3: {
          title: "اتمام ظرفیت",
          variant: "primary",
        },
        4: {
          title: "کنسل شده",
          variant: "danger",
        },
        5: {
          title: "به اتمام رسیده",
          variant: "danger",
        },
      },
      tableColumns: [
        {
          key: "masterId",
          label: "شناسه استاد",
        },
        {
          key: "masterFullName",
          label: "نام استاد",
        },
        {
          key: "groupClassName",
          label: "عنوان کلاس",
        },
        {
          key: "groupClassStatus",
          label: "وضعیت کلاس",
        },
        {
          key: "enable",
          label: "ضرب الاجل دارد؟",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    renderAddMasterToGroupClassDialog() {
      this.$bvModal.show("assign-master-to-group-class-dialog");
    },
    renderDeleteMasterFromGroupClassConfirmationDialog(selectedMaster) {
      this.tempSelectedMaster = selectedMaster;
      this.$bvModal.show("delete-master-from-group-class-confirmation-dialog");
    },
    changePage(pageNumber) {
      this.groupClassMasterListFilters.pageNumber = pageNumber;
      this.getAllMastersForGroupClass();
    },
    setPageNumberAndSendRequest() {
      this.groupClassMasterListFilters.pageNumber = 1;
      this.getAllMastersForGroupClass();
    },
    async getAllMastersForGroupClass() {
      try {
        if (this.selectedGroupClassId) {
          this.groupClassMasterListFilters.groupClassId =
            this.selectedGroupClassId;
        }
        this.isLoading = true;
        const _this = this;
        const getAllGroupClassMasters = new GetAllGroupClassMasters(_this);
        getAllGroupClassMasters.setRequestParam(
          _this.groupClassMasterListFilters
        );
        await getAllGroupClassMasters.fetch((res) => {
          if (res.isSuccess) {
            _this.groupClassMastersList = res.data.data;
            _this.totalCount = res.data.total;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    GroupClassStatusPicker,
    SearchInput,
    CustomTable,
    AddMasterToGroupClassDialog,
    DeleteMasterFromGroupClassConfirmationDialog,
    BLink,
    BButton,
    BBadge,
  },
};
import DeleteMasterFromGroupClassConfirmationDialog from "@/views/components/GroupClass/DeleteMasterFromGroupClassConfirmationDialog.vue";
import AddMasterToGroupClassDialog from "@/views/components/GroupClass/AddMasterToGroupClassDialog.vue";
import GroupClassStatusPicker from "@/views/components/GroupClass/GroupClassStatusPicker.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { GetAllGroupClassMasters } from "@/libs/Api/GroupClass";
import { BLink, BButton, BBadge } from "bootstrap-vue";
</script>
